export const servicesLinks = [
  { text: "Apply As Developer", link: "/opportunities/developer" },
  // { text: "Social Media Work", link: "/services/social-media-work" },
  { text: "Hire Top Talent", link: "/opportunities/client" },
  // { text: "Blockchain", link: "/services/blockchain" },
  // { text: "Dedicated Teams", link: "/services/dedicated-teams" },
];

export const aiLinks = [
  { text: "AI Services", link: "/services/ai" },
  { text: "AI Chatbot", link: "/services/ai-chatbot" },
  { text: "Generative AI", link: "/services/generative-ai" },
  { text: "Computer Vision", link: "/services/computer-vision" },
];
export const opportunitiesLinks = [
  { text: "Find Talent", link: "/opportunities/client" },
  { text: "Find Jobs", link: "/opportunities/developer" },
];

export const industriesLinks = [
  { text: "Banking", link: "/industries/banking" },
  { text: "Fintech", link: "/industries/fintech" },
  { text: "EdTech", link: "/industries/edtech" },
  { text: "Insurtech", link: "/industries/insurtech" },
  { text: "Marketing", link: "/industries/marketing" },
  { text: "Sports", link: "/industries/sports" },
];

export const navLinks = [
  { text: "Portfolio", link: "/portfolio" },
  { text: "Our Team", link: "/about-us" },
  { text: "Contact Us", link: "/contact" },
];
